var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericPage',[_c('template',{slot:"breadcrumb-items"},[_c('li',{staticClass:"active bold"},[_vm._v("Aclaraciones y reclamaciones.")])]),_c('template',{slot:"title"},[_vm._v(" Reporte por robo o extravío. ")]),_c('template',{slot:"body"},[_c('StealLossReportForm')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }